import { render, staticRenderFns } from "./vTableColumn.vue?vue&type=template&id=9dac3dd2&"
import script from "./vTableColumn.vue?vue&type=script&lang=js&"
export * from "./vTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dac3dd2')) {
      api.createRecord('9dac3dd2', component.options)
    } else {
      api.reload('9dac3dd2', component.options)
    }
    module.hot.accept("./vTableColumn.vue?vue&type=template&id=9dac3dd2&", function () {
      api.rerender('9dac3dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/vTableColumn.vue"
export default component.exports